export default {
  rating: {
    en: `Average rating: {ratingValue} ({ratingCount} ratings), {reviewCount} reviews`,
  },
  buttonTitle: {
    en: 'Subscribe for just {price}',
  },
}
